import * as Logger from 'loglevel';
import authService from '../../components/api-authorization/AuthorizeService';
import { UtilConstant } from 'hub-utilities'
import { convertObjToFolderTree } from '../../components/post-authorization/libraries/DataHandler';
import PermissionManager from '../../util/PermissionManager';

export class FtnReducer {
    //Add action here:
    
    onFtDeletePermission = (state, ftnContent) => {
        const userId = authService.getCurrentHubUser().id;
        const userType = authService.getUserType();

        const isUserInSecurityGroups = state.folderSecurityGroups.some(group =>
            group.users.includes(userId)
        );

        if (ftnContent.principalId === userId || isUserInSecurityGroups) {
            const folderId = ftnContent.folderId;
            Logger.debug(`FtnSink: deleting user permissions for Folder with Id: ${folderId}`);

            const updatedTree = state.hubFolderTree.map(folder => {
                if (folder.id === folderId) {

                    const newPermissions = folder.permissions.filter(perm =>
                        perm.principalId !== ftnContent.principalId
                    );

                    // If no permissions are left
                    if (newPermissions.length === 0) {

                        return {
                            ...folder,
                            permissions: newPermissions,
                            folderPermissions: userType === UtilConstant.HUB_USER_TYPE.HUB_ADMIN ? 1 : -1
                        };
                    }

                    // If permissions remain, update the folder with the new permissions
                    return {
                        ...folder,
                        permissions: newPermissions,
                        folderPermissions: PermissionManager.chooseEffectivePermission(newPermissions, userId)
                    };
                }
                return folder;
            });

            let newState = {
                ...state,
                hubFolderTree: updatedTree,
                bTriggerUpdate: false
            };

            return newState;
        }

        return state;
    };



    onFtAddPermission = (state, ftnContent) => {
        const userId = authService.getCurrentHubUser().id;

        const isUserInSecurityGroups = state.folderSecurityGroups.some(group =>
            group.users.includes(userId)
        );

        if (ftnContent.securityDef.principalId === userId || isUserInSecurityGroups) {
            const folderId = ftnContent.securityDef.securityId;

            const updatedTree = state.hubFolderTree.map(folder => {
                if (folder.id === folderId) {
                    const newPermissions = [...folder.permissions, ftnContent.securityDef];
                    return {
                        ...folder,
                        permissions: newPermissions,
                        folderPermissions: PermissionManager.chooseEffectivePermission(newPermissions, userId)
                    };
                }
                return folder;
            });

            Logger.debug(`FtnSink: updating user permissions for Folder with Id: ${folderId}`);

            return {
                ...state,
                hubFolderTree: updatedTree,
                bTriggerUpdate: false
            };
        }
        return state;
    };

    onFtUpdatePermission = (state, ftnContent) => {
        const userId = authService.getCurrentHubUser().id;
        const isUserInSecurityGroups = state.folderSecurityGroups.some(group =>
            group.users.includes(userId)
        );

        if (ftnContent.securityDef.principalId === userId || isUserInSecurityGroups) {
            const folderId = ftnContent.securityDef.securityId;

            const updatedTree = state.hubFolderTree.map(folder => {
                if (folder.id === folderId) {
                    const newPermissions = folder.permissions.map(perm =>
                        perm.principalId === ftnContent.securityDef.principalId ? ftnContent.securityDef : perm
                    );

                    return {
                        ...folder,
                        permissions: newPermissions,
                        folderPermissions: PermissionManager.chooseEffectivePermission(newPermissions, userId)
                    };
                }
                return folder;
            });

            Logger.debug(`FtnSink: updating user permissions for Folder with Id: ${folderId}`);

            return {
                ...state,
                hubFolderTree: updatedTree,
                bTriggerUpdate: false
            };
        }
        return state;
    };

    onFtAddFolder = (state, ftnContent) => {
        Logger.debug(`FtnSink: adding new Folder with Id: ${ftnContent.folderId}`);
        const newFolder = convertObjToFolderTree(ftnContent.hubObject)
        const updatedTree = [...state.hubFolderTree, newFolder]
        let newState = {
            ...state,
            hubFolderTree: updatedTree,
            bTriggerUpdate: false
        }
        return newState;
    }
    onFtUpdateFolder = (state, ftnContent) => {
        Logger.debug(`FtnSink: updating Folder with Id: ${ftnContent.folderId}`);
        const newFolder = convertObjToFolderTree(ftnContent.hubObject)
        const updatedTree = state.hubFolderTree.map((folder) =>
            folder.id === ftnContent.folderId
                ? {
                    ...folder,
                    parentId : newFolder.parentId,
                    id : newFolder.id,
                    name : newFolder.name,
                    securityOption : newFolder.securityOption
                }
                : folder
        );
        let newState = {
            ...state,
            hubFolderTree: updatedTree,
            bTriggerUpdate: false
        }
        return newState;
    }
    onFtDeleteFolder = (state, ftnContent) => {
        Logger.debug(`FtnSink: deleting Folder with Id: ${ftnContent.folderId}`);
        const updatedTree = state.hubFolderTree.filter((folder) => folder.id !== ftnContent.folderId);
        let newState = {
            ...state,
            hubFolderTree: updatedTree,
            bTriggerUpdate: false
        }
        return newState;
    }
}

const ftnReducer = new FtnReducer();
export default ftnReducer;
